import { useState } from 'react'

import Styles from './Properties.module.scss'

import { useFinderContext } from 'screens/Finder/FinderContext'
import { usePropertiesList } from 'common/PropertiesList/usePropertiesList'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { usePropertiesPermissions } from 'hooks/usePropertiesPermissions'

import { ChangeVisibilityButton } from './ChangeVisibilityButton'
import { DeleteProperty } from './DeleteProperty'
import { EditableProperty } from './Properties'
import { PropertyForm } from 'common/PropertyForm/PropertyForm'
import { Property, PropertyType, PropertiesForForms } from 'api/clients/PropertyClient'
import { isCalendarProperty } from 'screens/Finder/components/views/CalendarView/utils'

type Props = {
  editableProperty: EditableProperty
  onClose: () => void
  isRename?: boolean
}

export const EditFolderProperty = ({ editableProperty, onClose, isRename = false }: Props) => {
  const { property } = editableProperty
  const { canEdit } = usePropertiesPermissions(property)
  const { filesView } = useFinderContext()
  const [type, setType] = useState<PropertyType>(property.type)

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const workspaceKey = filesView!.schema!.workspace.key

  const { updateProperty } = usePropertiesList({ workspaceId: workspaceKey })

  const handleUpdateProperty = async (property: Property, isUndoAction: boolean | undefined) => {
    const res = await updateProperty(property, isUndoAction)
    onClose()
    showToastMessage(`"${property.name}" has been updated.`)
    return res
  }

  const propertyTypes = Object.keys(PropertyType)
    .map((key) => ({
      type: PropertyType[key as keyof typeof PropertyType],
      name: String(PropertyType[key as keyof typeof PropertyType]),
    }))
    .filter(({ type }) => PropertiesForForms.includes(type))

  return (
    <>
      <PropertyForm
        variant="large"
        type={type}
        onSetType={setType}
        propertyTypes={propertyTypes}
        property={property}
        isRename={isRename}
        onUpdate={(property, isUndoAction) => {
          onClose()
          return handleUpdateProperty(property, isUndoAction)
        }}
        disabled={!canEdit}
      />
      {!isCalendarProperty({ filesView, propertyId: property?.id }) && (
        <>
          {!canEdit && (
            <div className={Styles.mdText}>
              This property is created in a folder that you do not have edit access to.
            </div>
          )}
          <div className={Styles.divider}></div>
          <ChangeVisibilityButton editableProperty={editableProperty} onClose={onClose} />
          {canEdit && <DeleteProperty property={property} onClose={onClose} />}
        </>
      )}
    </>
  )
}
